import { render } from "./VeiculosTable.vue?vue&type=template&id=eafd16ea&ts=true"
import script from "./VeiculosTable.vue?vue&type=script&lang=ts"
export * from "./VeiculosTable.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__